import { cx } from '@libs/classnames';

import styles from './Toggle.module.css';

type Props = {
  className?: string;
  variant?: 'old' | 'new';
  value?: boolean;
  onToggle?: (value: boolean) => void;
};

export function Toggle({ className, variant = 'old', value = false, onToggle }: Props) {
  return (
    <div
      className={cx(styles.toggle, className, {
        [styles.on]: value,
        [styles.off]: !value,
        [styles.variant_old]: variant === 'old',
        [styles.variant_new]: variant === 'new',
      })}
      onClick={() => onToggle?.(!value)}
    >
      <div className={styles.trigger}>
        <span aria-hidden={value}>ВЫКЛ</span>
        <span aria-hidden={!value}>ВКЛ</span>
      </div>
    </div>
  );
}
